

























































































































































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { demoServer, doublePrevention, hiddenDangerLibraryServer, performanceServer, yunnanDataViewServer } from '@/api/installServer';
import PagingUnit from '@/components/paging/paging.vue';
import { TableStripe } from '@/mixins/tableStripe';
import DetailsDialogA from './box-8-unit-2.vue';
import DetailsDialogB from './box-8-unit-3.vue';
import DetailsDialogC from './box-8-unit-4.vue';

@Component({
  components: { PagingUnit, DetailsDialogA, DetailsDialogB, DetailsDialogC },
  mixins: [TableStripe],
})
export default class Home extends Vue {
  private visible = false;
  private title: any = '';
  private form: any = {};
  private data: any = {};
  private total: any = 0;
  private tableData: any = [];
  private tableDataB: any = [];
  tableDataC: any = [];
  oneColumnType = 'index'; // 决定第一列是索引还是选择
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  type: any = 'risk';

  finishFlag: any;
  deptName: any = '';

  searchTimeRisk: any = [];
  searchTimeSafe: any = [];
  searchTimeDanger: any = [];

  rowData: any = {};

  loading: any = false;

  deptId: any = '';

  private mounted() {}

  private async showDialog(data: any) {
    this.rowData = data;
    this.type = 'risk'; // 风险随查 risk, 安全检查 safe, 发现隐患 danger
    // this.typeTime = 'day';
    this.visible = true;

    this.title = '检查统计列表';

    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };

    this.searchTimeRisk = [data.startTime, data.endTime];
    this.searchTimeSafe = [data.startTime, data.endTime];
    this.searchTimeDanger = [data.startTime, data.endTime];

    this.deptId = data.deptId;
    this.getListData();
  }

  showDetailSafe(data: any) {
    let DetailsDialogRef: any;
    if (this.type === 'safe') {
      DetailsDialogRef = this.$refs['DetailsDialogRefA'];
    }
    DetailsDialogRef.showDialog(data);
  }

  showDetailDanger(data: any) {
    let DetailsDialogRef: any;
    if (this.type === 'danger') {
      DetailsDialogRef = this.$refs['DetailsDialogRefB'];
    }
    DetailsDialogRef.showDialog(data);
  }

  showDetailRisk(data: any) {
    let DetailsDialogRef: any;
    if (this.type === 'risk') {
      DetailsDialogRef = this.$refs['DetailsDialogRefC'];
    }
    DetailsDialogRef.showDialog(data);
  }

  getData(type: any) {
    this.loading = true;
    this.type = type;
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };

    if (this.type === 'risk') {
      this.getDataRisk();
    }
    if (this.type === 'safe') {
      this.getDataSafe();
    }
    if (this.type === 'danger') {
      this.getDataDanger();
    }
  }

  changeTimeRisk() {
    this.getDataTime(null);
  }
  changeTimeSafe() {
    this.getDataTime(null);
  }
  changeTimeDanger() {
    this.getDataTime(null);
  }

  getDataTime(type: any) {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };

    this.getListData();
  }

  private handleSizeChange(size: number) {
    this.queryDataForm.pageSize = size;
    this.getListData();
  }

  private handleCurrentChange(pageNo: number) {
    this.queryDataForm.pageNo = pageNo;
    this.getListData();
  }

  getListData() {
    this.loading = true;
    if (this.type === 'risk') {
      this.getDataRisk();
    }
    if (this.type === 'safe') {
      this.getDataSafe();
    }
    if (this.type === 'danger') {
      this.getDataDanger();
    }
  }

  private getDataRisk() {
    const form: any = {
      current: (this.queryDataForm as any).pageNo,
      size: (this.queryDataForm as any).pageSize,
      startTime: this.searchTimeRisk ? this.searchTimeRisk[0].slice(0, 10) + ' 00:00:00' : null,
      endTime: this.searchTimeRisk ? this.searchTimeRisk[1].slice(0, 10) + ' 23:59:59' : null,
      deptIncludeSub: this.deptId,
    };
    doublePrevention
      .getHandyCheckList(form)
      .then((res: any) => {
        this.loading = false;
        this.tableDataC = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
        throw error;
      });
  }
  private getDataSafe() {
    const form: any = {
      pageNo: (this.queryDataForm as any).pageNo,
      pageSize: (this.queryDataForm as any).pageSize,
      startCheckDate: this.searchTimeSafe ? this.searchTimeSafe[0].slice(0, 10) : null,
      endCheckDate: this.searchTimeSafe ? this.searchTimeSafe[1].slice(0, 10) : null,
      deptIdIncludeSub: this.deptId,
    };
    performanceServer
      .getList(form)
      .then((res: any) => {
        this.loading = false;
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
        throw error;
      });
  }
  private getDataDanger() {
    hiddenDangerLibraryServer
      .getHazardManageList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        startDate: this.searchTimeDanger ? this.searchTimeDanger[0].slice(0, 10) : null,
        endDate: this.searchTimeDanger ? this.searchTimeDanger[1].slice(0, 10) : null,
        initiateDepartmentId: this.deptId,
      })
      .then((res: any) => {
        this.loading = false;
        this.tableDataB = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  checkDetail(row: any) {
    if (this.type === 'risk') {
    }
    if (this.type === 'safe') {
    }
    if (this.type === 'danger') {
    }
  }

  private hideDialog() {
    this.visible = false;
  }
}
